import { render } from "./ContactStepCategoryContent.vue?vue&type=template&id=5a5a85f7"
import script from "./ContactStepCategoryContent.vue?vue&type=script&lang=js"
export * from "./ContactStepCategoryContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__